<template>
  <!-- 训练模型 -->
  <div class="training-step-model-train">
    <div class="training">
      <div class="intxt">
        <label class="label">
          <i class="required">*</i>选择训练模型：
        </label>
        <el-select
          class="select-box select-box-training"
          v-model="activeModel"
          placeholder="请选择训练模型"
          filterable
        >
          <el-option
            v-for="item in modelOptions"
            :key="item.modelId"
            :label="item.modelName"
            :value="item.modelId"
          ></el-option>
        </el-select>
      </div>
      <div class="intxt select-box">
        <label class="label" for>
          <i class="required">*</i>选择模型数据：
        </label>
        <el-select
          class="select-box select-box-training"
          v-model="activeDataset"
          placeholder="请选择模型数据"
          filterable
        >
          <el-option
            v-for="item in datasetOptions"
            :key="item.datasetId"
            :label="item.datasetName"
            :value="item.datasetId"
          ></el-option>
        </el-select>
      </div>
      <div class="intxt">
        <label class="label checkbox-label" ></label>
        <el-checkbox-group
          class="checkbox"
          v-model="trainingList"
          @change="selectTrainingTags"
        >
          <el-checkbox
            v-for="(item, idx) in Label.records"
            :label="item.labelId"
            :key="item.labelId || idx"
            :disabled="modelLimitButtonShow"
            >{{ item.labelName }}</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <div class="tips" v-show="isMoreThan.val && Label.records && !modelLimitButtonShow">
        <div class="error">
          <i>+</i>
          <span
            >训练模型至少需要选中<b> {{ isMoreThan.limit }} </b>个标签</span
          >
        </div>
      </div>
      <div class="tips" v-if="unfinished && !modelLimitButtonShow">
        <div class="error">
          <i>+</i>
          <span>{{ `[${unfinishedLabl}]` }}{{ trainingRuleTips(modelType) }} </span>
        </div>
      </div>
      <div class="btns">
        <el-button
          type="primary"
          :class="['btn-primary', {'events-disable': teacherOrStudentState ? (withdrawReleaseStatus || releaseStatus) : releaseStatus}]"
          @click="trainingStart"
        >开始训练</el-button>
      </div>
    </div>
    <!-- 模型信息 -->
    <ModelInformationBox
      :trainingId="trainingId"
      :navType="navType"
      :modelType="modelType"
      :modelInformation="modelInformation"
      @toModelTrain="toModelTrain"
      :releaseStatus="releaseStatus"
      :trainModelShow="trainModelShow"
      :quoteModelNum="quoteModelNum"
      @getQuoteModelNum="getQuoteModelNum"
      :withdrawReleaseStatus="withdrawReleaseStatus"
      :teacherOrStudentState="teacherOrStudentState"
    ></ModelInformationBox>
  </div>
</template>

<script>
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js' // 项目标注接口

import ModelInformationBox from './components/ModelInformationBox.vue'

import { debounce } from 'lodash' // 引入lodash数组函数方法

export default {
  name: "TrainingStepModelTrain",
  components: { ModelInformationBox },
  props: {
    trainingId: {
      type: String,
      default: ''
    },
    navType: {
      type: String,
      default: ''
    },
    modelType: {
      type: String,
      default: ''
    },
    modelOptions: {
      type: Array,
      default: []
    },
    datasetOptions: {
      type: Array,
      default: []
    },
    modelInformation: {
      type: Object,
      default: {}
    },
    modelLimitButtonShow: {
      type: Boolean,
      default: false
    },
    releaseStatus: {
      type: Boolean,
      default: false
    },
    trainModelShow: {
      type: Boolean,
      default: false
    },
    withdrawReleaseStatus: {
      type: Boolean,
      default: false
    },
    teacherOrStudentState: {
      type: Boolean,
      default: false
    },
    quoteModelNum: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      activeModel: "", // 激活的模型
      activeDataset: "", // 数据集
      trainingList: [],
      // 模型标签
      Label: {
        records: [],
        PageIndex: 1,
        PageSize: 999,
        total: 0
      },
      unfinished: false,
      unfinishedLabl: false,
    }
  },
  computed: {
    isMoreThan() {
      var val = true,
        limit = 0,
        modelType = this.modelType;

      if (modelType === "1" || modelType === "3" || modelType === "4" || modelType === "5" || modelType === "6") {
        limit = 2;
      } else if (modelType === "2") {
        limit = 1;
      }

      val = this.trainingList.length < limit;

      return { limit: limit, val: val };
    },
  },
  watch: {
    modelOptions: {
      handler(val) {
        if (val && val.length) {
          this.activeModel = val[0].modelId;
        } else {
          this.activeModel = '';
        }
      },
      deep: true,
      immediate: true,
    },
    datasetOptions: {
      handler(val) {
        if (val && val.length) {
          this.activeDataset = val[0].datasetId;
        } else {
          this.activeDataset = '';
        }

        if (this.activeDataset) {
          // 根据数据集id查询标签下的数量
          this.getLabelNumByDatasetId();
        }
      },
      deep: true,
      immediate: true,
    },
    modelLimitButtonShow: {
      handler(val) {
        if (val) {
          let labelIds = this.modelInformation.labelIds;
          this.trainingList = labelIds.split(',');
        } else {
          this.trainingList = [];
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {},
  methods: {
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },
    // 训练模型提示语
    trainingRuleTips(type) {
      if (type == 1 || type == 3 || type == 5) {
        return `标签下的${this.modelTypeCompany(type)}不足20${type == 1 ? '张':'个'}，请补充其数量~`;
      } else if (type == 4 || type == 6) {
        return `标签下的${type == 4 ? '文本标注':'音频片段'}不足20个，请补充其数量~`;
      } else if (type == 2) {
        return '标签下的图片不足40张，请补充其数量~';
      }
    },

    toModelTrain() {
      this.$emit('toModelTrain')
    },
    getQuoteModelNum() {
      this.$emit('getQuoteModelNum')
    },
    // 根据数据集id查询标签下的数量
    getLabelNumByDatasetId() {
      let data = {
        datasetId: this.activeDataset,
        editorType: this.modelType,
      }
      MARKCENTER.getLabelNumByDatasetId(data).then(result => {
        if (result.isSuccess) {
          this.Label.records = result.data
        } else {
          this.Label.records = []
          this.$message.error(result.returnMsg);
        }
      }).catch(err => {
        console.log('error', err);
      });
    },

    // 选中训练模型标签
    selectTrainingTags(vals) {
      let { modelType } = this;
      this.unfinished = false; //初始化;
      // 图片分类、文本分类、文本标注、音频分类、音频标注
      if (modelType == 1 || modelType == 3 || modelType == 4 || modelType == 5 || modelType == 6) {
        this.unfinishedLabl = this.trainingRuleFunction (vals, 20); // 统计标签下数量,返回不符合标签
      } else { // 物体检测
        this.unfinishedLabl = this.trainingRuleFunction (vals, 40); // 统计标签下数量,返回不符合标签
      }
    },
    trainingRuleFunction (vals, num) {
      let { Label, modelType } = this;
      let arr = [];
      Label.records.forEach(item1 => {
        vals.forEach(item2 => {
          let fileNum = null;
          fileNum = item1.fileNum;
          // if (modelType == 1 || modelType == 2) {
          //   fileNum = item1.imgNum;
          // } else if (modelType == 3 || modelType == 4) {
          //   fileNum = item1.textNum;
          // } else {
          //   fileNum = item1.audioNum;
          // }
          if (item2 === item1.labelId && fileNum < num) {
            this.unfinished = true;
            arr.push(item1.labelName);
          }
        });
      });
      return arr.toString();
    },
    // 开始训练
    trainingStart() {
      if (!this.activeModel || !this.activeDataset || this.trainingList.length < this.isMoreThan.limit) {
        return;
      }
      if (this.unfinished) {
        return;
      }
      this.toStartTraining()
    },
    // 训练模型：防抖
    toStartTraining:debounce(function(type) {
      let trainingId = this.trainingId,
        modelType = this.modelType,
        modelId = this.activeModel,
        datasetId = this.activeDataset,
        labelIds = this.trainingList,
        labelIdList = [],
        labelNames = [],
        data = {};

      this.Label.records.forEach(item => {
        labelIds.forEach(i => {
          if (i == item.labelId) {
            labelIdList.push(item.labelId);
            labelNames.push(item.labelName);
          }
        });
      });
        
      data = {
        datasetId: datasetId, // 数据集id
        // labelIds: labelIds.join(","), // 标签id集合
        labelIds: labelIdList.join(","), // 标签id集合
        labelNames: labelNames.join(","), // 标签名称集合
        modelId: modelId, // 模型id
        editorType: modelType, // 类型
        trainingId: trainingId // 实训id
      };

      MARKCENTER.addTrainModel(data).then(result => {
        if (result.isSuccess) {
          this.$emit('getTrainModelByModelId')
          this.$message.success(result.returnMsg);
        } else {
          this.$message.error(result.returnMsg);
        }
      }).catch(err => {
        console.log('error', err);
      });
    }, 500),
  },
}
</script>

<style lang="scss" scoped>
.training-step-model-train {
  height: 100%;
  padding-top: 24px;
  display: flex;
  justify-content: space-between;

  .training {
    flex: 1;
    height: 100%;
  }
}
.intxt {
  width: 100%;
  font-size: 14px;
  display: flex;
  margin-bottom: 10px;
  .label {
    line-height: 36px;
    &.checkbox-label {
      width: 8em;
    }
  }
  .select-box {
    flex: 1;
  }
  .checkbox {
    margin-top: 20px;
  }
  &::v-deep .el-icon-arrow-up:before {
    content: "\e78f";
  }
  &::v-deep {
    .el-input__count {
      line-height: 1.5;
    }
    .el-input__inner,
    .el-textarea__inner {
      width: 100%;
      height: 36px;
      position: relative;
    }
    .el-textarea__inner {
      font-family: sans-serif;
      resize: none;
    }
    .el-input .el-input__count {
        position: absolute;
        top: 72%;
        right: 0.6em;
    }
    .el-input__count {
        position: absolute;
        right: 17px;
        bottom: -18px;
        padding: 0 5px;
    }
    .el-input__icon {
      height: 36px;
      line-height: 36px;
    }
  }
}

.tips {
  margin-top: 20px;
  margin-left: 8em;
  font-size: $font_size;
  line-height: 40px;
  .error {
    border-left: 2px solid #ff6b75;
    background: #fff1f2;
    color: #ec414c;
    & > i {
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin: 0 10px;
      background: #fd626c;
      color: #fff;
      font-size: 15px;
      line-height: 16px;
      vertical-align: middle;
      text-align: center;
      transform: rotate(45deg);
      user-select: none;
    }
    b {
      font-weight: normal;
    }
  }
}

.btns {
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
  text-align: center;
  button {
    margin-right: 35px;
    &:last-child {
      margin-right: 0;
    }
  }
}
.btn-primary,
.btn-cancel {
  height: $height_btn;
  padding: 0 25px;
  line-height: $height_btn;
}
.btn-primary {
  border-color: $bgc_btn_primary;
  background-color: $bgc_btn_primary;
  &:hover {
    background-color: $bgc_btn_primary_hover;
    border-color: $bgc_btn_primary_hover;
  }
}
.btn-cancel {
  border-color: $bgc_btn_cancel;
  background-color: $bgc_btn_cancel;
  color: $color_btn_cancel;
  &:hover {
    background-color: $bgc_btn_cancel_hover;
    border-color: $bgc_btn_cancel_hover;
  }
}

</style>